import CookieConsent from "react-cookie-consent";

import './css/custom.css';
import './css/cookie-consent.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import BootstrapNavbar from './components/BootstrapNavbar';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <div className="App">
      <div className="Site-content">
        <Header />
        <AuthProvider>
          <BootstrapNavbar />
        </AuthProvider>
        <Footer />
      </div>

      <CookieConsent
        location="bottom"
        buttonText="Accetta tutti"
        declineButtonText="Solo necessari"
        cookieName="LIBaaSConsentCookie"
        enableDeclineButton
        flipButtons
        expires={150}
        containerClasses="cookie-consent-container"
        contentClasses="cookie-consent-content"
        buttonClasses="cookie-consent-accept"
        declineButtonClasses="cookie-consent-decline"
        buttonWrapperClasses="cookie-consent-buttons"
        disableStyles={true}
      >
        <div className="cookie-consent-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <circle cx="8" cy="9" r="1" fill="currentColor"/>
            <circle cx="15" cy="8" r="1" fill="currentColor"/>
            <circle cx="10" cy="14" r="1" fill="currentColor"/>
            <circle cx="16" cy="13" r="1" fill="currentColor"/>
            <circle cx="12" cy="17" r="1" fill="currentColor"/>
          </svg>
        </div>
        <div className="cookie-consent-text">
          <strong>Informativa sui Cookie</strong>
          <p>
            Questo sito utilizza cookie tecnici e di profilazione per migliorare la tua esperienza di navigazione.
            Puoi scegliere di accettare tutti i cookie o solo quelli necessari al funzionamento del sito.
          </p>
          <a href="https://www.unimib.it/privacy-cookie-policy" target="_blank" rel="noopener noreferrer">
            Maggiori informazioni
          </a>
        </div>
      </CookieConsent>

    </div>
  );
}

export default App;
